class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    console.log("CartDrawer opened");
    window.dispatchEvent(new CustomEvent("__CartDrawer_opened", { detail: null }));
    this.updateProgressBar();
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.productId = parsedState.id;

    // Render sections
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement && parsedState.sections[section.id]) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    // Call the progress bar updater after content is rendered
    this.updateProgressBar();

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  // --- Progress bar logic ---
  async updateProgressBar() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const subtotal = (cart.items_subtotal_price || 0) / 100;

      const thresholds = [89, 109]; // first: free shipping, second: bonus product
      const progressBar = document.querySelector('.progress-bar-fill');
      const milestone1 = document.querySelector('.milestone-1');
      const milestone2 = document.querySelector('.milestone-2');
      const text = document.querySelector('#cartRewardText');

      if (progressBar) progressBar.style.width = (Math.min(subtotal, thresholds[1]) / thresholds[1]) * 100 + '%';
      if (milestone1) milestone1.style.left = (thresholds[0] / thresholds[1]) * 100 + '%';
      if (milestone2) milestone2.style.left = '100%';

      if (text) {
        if (subtotal < thresholds[0]) {
          text.innerHTML = ` Only $${(thresholds[0] - subtotal).toFixed(2)} away from FREE Shipping and Nail Strengthening Oil`;
        } else if (subtotal < thresholds[1]) {
          text.innerHTML = `Add $${(thresholds[1] - subtotal).toFixed(2)} to get FREE Glue Remover`;
        } else {
          text.innerHTML = `Congratulations! Free shipping and all free gifts activated`;
        }
      }

      // Hide bonus item quantity selectors if needed
      const bonusVariantId = 43814392332381;
      document.querySelectorAll(`[data-variant-id="${bonusVariantId}"], [data-line-variant-id="${bonusVariantId}"]`).forEach(el => {
        const pop = el.querySelector('.quantity-popover, quantity-popover');
        if (pop) pop.style.display = 'none';
        el.querySelectorAll('quantity-input, .quantity, .cart-item__quantity, .quantity-selector').forEach(q => q.style.display = 'none');
      });

    } catch (err) {
      console.error('Error updating progress bar:', err);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector(selector);
    return section ? section.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
